"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");
/**
 * Release state enumeration.
 * @author Radek Beran
 */


var ReleaseState;

(function (ReleaseState) {
  ReleaseState["New"] = "New";
  /** Optimal prices are being computed. Users cannot edit the release. */

  ReleaseState["Computing"] = "Computing";
  /** Prices cannot be computed due to an error while computing prices for all release parts of release */

  ReleaseState["ComputationFailed"] = "ComputationFailed";
  /** Optimal prices for all items were computed (or fallback prices were used). Users can now edit the prices. */

  ReleaseState["Opened"] = "Opened";
  /** Separate state related to situation when release is in the middle of reopening process. */

  ReleaseState["Reopening"] = "Reopening";
  /**
   * All parts of the release were approved. Note that release can be exported
   * if at least on part is approved. So release does not have to be ever in this state.
   */

  ReleaseState["Approved"] = "Approved";
  /**
   * Release items are checked by repricing constraints.
   * All release's parts are locked and should not be edited even by the user owning the lock.
   */

  ReleaseState["ExportChecking"] = "ExportChecking";
  /**
   * User is currently preparing an export.
   * User has exclusive access to the release. He/She is selecting items for the export.
   * All release's parts are locked and should not be edited even by the user owning the lock.
   */

  ReleaseState["ExportEditing"] = "ExportEditing";
  /** Release items were checked and their export was started. */

  ReleaseState["ExportStarted"] = "ExportStarted";
  ReleaseState["ExportFailed"] = "ExportFailed";
  /** Release can be cancelled even if it is approved, but only if it is not released yet. */

  ReleaseState["Cancelled"] = "Cancelled";
  /** Terminal state (for some releases). All work on the release has been done. */

  ReleaseState["Released"] = "Released";
  /**
   * Terminal state (but not all releases will end up in this state). Every price in this release expired and it cannot be reopened.
   */

  ReleaseState["Inactive"] = "Inactive";
})(ReleaseState = exports.ReleaseState || (exports.ReleaseState = {})); // Register states of non-terminated release here!


var activeReleaseStates = immutable_1.List.of(ReleaseState.New, ReleaseState.Computing, ReleaseState.ComputationFailed, ReleaseState.Opened, ReleaseState.Approved, ReleaseState.ExportChecking, ReleaseState.ExportEditing, ReleaseState.ExportStarted, ReleaseState.ExportFailed);
exports.activeReleaseStates = activeReleaseStates;
/**
 * Enumerates state within which a prices of a release can be recalculated.
 */

var PRICE_RECALCULATION_STATES = immutable_1.Set.of(ReleaseState.New, ReleaseState.Reopening, ReleaseState.Opened, ReleaseState.ComputationFailed);
exports.PRICE_RECALCULATION_STATES = PRICE_RECALCULATION_STATES;